import http, { authHeader } from './http';
import { API_URL } from '../constants/config';

export const getUsers = (token, params) =>
  http.get('/api/admin/users', { params, headers: authHeader(token) }).then((r) => r.data);

export const getUserById = (token, id) =>
  http.get(`/api/admin/users/${id}`, { headers: authHeader(token) }).then((r) => r.data);

export const updateUser = (token, id, data) =>
  http.put(`/api/admin/users/${id}`, data, { headers: authHeader(token) }).then((r) => r.data);

export const blockUser = (token, id, type, blocked_until) =>
  http.post(`/api/admin/users/${id}/block`, { type, blocked_until }, { headers: authHeader(token) }).then((r) => r.data);

export const unblockUser = (token, id) =>
  http.post(`/api/admin/users/${id}/unblock`, {}, { headers: authHeader(token) }).then((r) => r.data);

export const forceLogout = (token, id) =>
  http.post(`/api/admin/users/${id}/force-logout`, {}, { headers: authHeader(token) }).then((r) => r.data);

export const resetPassword = (token, id) =>
  http.post(`/api/admin/users/${id}/reset-password`, {}, { headers: authHeader(token) }).then((r) => r.data);

export const changePassword = (token, id, password) =>
  http.post(`/api/admin/users/${id}/change-password`, { password }, { headers: authHeader(token) }).then((r) => r.data);

export const setAdmin = (token, id, is_admin) =>
  http.post(`/api/admin/users/${id}/set-admin`, { is_admin }, { headers: authHeader(token) }).then((r) => r.data);

export const addToChat = (token, id) =>
  http.post(`/api/admin/users/${id}/add-to-chat`, {}, { headers: authHeader(token) }).then((r) => r.data);

export const removeFromChat = (token, id) =>
  http.post(`/api/admin/users/${id}/remove-from-chat`, {}, { headers: authHeader(token) }).then((r) => r.data);

export const getUserSubscriptions = (token, id) =>
  http.get(`/api/admin/users/${id}/subscriptions`, { headers: authHeader(token) }).then((r) => r.data);

// subscription_id — отменить одну подписку (иначе все активные); revoke_access — закрыть доступ сейчас
export const cancelUserSubscriptions = (token, id, { subscription_id, revoke_access } = {}) =>
  http
    .post(`/api/admin/users/${id}/subscriptions/cancel`, { subscription_id, revoke_access }, { headers: authHeader(token) })
    .then((r) => r.data);

export const syncChat = (token) =>
  http.post('/api/admin/sync-chat', {}, { headers: authHeader(token) }).then((r) => r.data);

// Скачивает CSV через fetch с Authorization заголовком (не через URL с токеном)
export const downloadCsv = async (token) => {
  const response = await fetch(`${API_URL}/api/admin/users/export-csv`, {
    headers: authHeader(token),
  });
  if (!response.ok) throw new Error('Ошибка экспорта');
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'users.csv';
  a.click();
  URL.revokeObjectURL(url);
};
